/**
 * OperationsReportScreen — full-width operations report (PR8 / G1).
 * Reuses Settings → Accounting → Operations panel; no fork.
 */
import { useNavigate } from 'react-router-dom'
import OperationsReportPanel from '../settings/panels/OperationsReportPanel'

export default function OperationsReportScreen() {
  const navigate = useNavigate()

  return (
    <>
      <div className="topbar">
        <div className="crumb">
          <button
            type="button"
            className="btn b-gh btn-sm"
            onClick={() => navigate('/dashboard')}
            data-testid="ops-report-back"
          >
            ← Dashboard
          </button>
          <b style={{ marginLeft: 10 }}>Operations report</b>
        </div>
      </div>
      <div className="pc">
        <OperationsReportPanel />
      </div>
    </>
  )
}
